import { useQuery } from '@betterment/js-runtime';
import { faker } from '@faker-js/faker'; // eslint-disable-line import/no-extraneous-dependencies
import { atom, useAtomValue, useSetAtom } from 'jotai';
import { atomWithReset } from 'jotai/utils';

import { urlBuilder } from '../../Shared/urlBuilder';

type SessionState = { agentId: string; agentAliasId: string; sessionId: string };

const sessionStateAtom = atomWithReset<SessionState | null>(null);

const setAgentConfigAtom = atom(null, (_, set, config: { agentId: string; agentAliasId: string }) => {
  set(sessionStateAtom, {
    ...config,
    sessionId: faker.datatype.uuid(),
  });
});

export const useSessionState = () => {
  const sessionState = useAtomValue(sessionStateAtom);
  const setAgentConfig = useSetAtom(setAgentConfigAtom);

  return {
    sessionState,
    setAgentConfig,
  };
};

type AgentSummary = {
  id: string;
  name: string;
  description: string;
  aliases: {
    id: string;
    name: string;
    description: string;
  }[];
};

export const useAgents = () => {
  const { data, loading } = useQuery<{ agents: AgentSummary[] }>(urlBuilder.apiV2AgentsAdminAgents.absolute());

  return { data: data?.agents ?? [], isLoading: loading };
};
